/**
 * The status a waiting item reads as in the view engine under option a (D-0159): its own column and
 * group on every board and list, after every real status. Not a stored status: nothing writes it.
 *
 * A leaf, re-exported by `waiting-on.ts`: the launch entry names this status (the list's server
 * filter, a part's figure link) and nothing else of the waits, so it does not carry their rules and
 * words (about 4 KB; T-0770, the entry budget).
 */
export const WAITING_STATUS = {
  key: 'waiting',
  name: 'Waiting',
  color: '#0284c7',
  position: 100000,
} as const;
